import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=35cdc95d&scoped=true&"
import script from "./TodoList.vue?vue&type=script&lang=js&"
export * from "./TodoList.vue?vue&type=script&lang=js&"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=35cdc95d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdc95d",
  null
  
)

export default component.exports